/**
 * Parse partial JSON strings, handling incomplete/streaming JSON data.
 * Based on LangChain's implementation:
 * https://github.com/langchain-ai/langchainjs/blob/main/langchain-core/src/utils/json.ts#L31
 *
 * @param s - The JSON string to parse (may be incomplete)
 * @returns The parsed object or null if parsing fails
 */
export function parsePartialJson(s: string): any {
  // Handle undefined input
  if (typeof s === 'undefined') {
    return null;
  }

  // First, try direct JSON parsing
  try {
    return JSON.parse(s);
  } catch (error) {
    // Continue if direct parsing fails
  }

  // Initialize parsing variables
  let new_s = '';
  const stack: string[] = [];
  let isInsideString = false;
  let escaped = false;

  // Process each character
  for (let char of s) {
    if (isInsideString) {
      if (char === '"' && !escaped) {
        isInsideString = false;
      } else if (char === '\n' && !escaped) {
        char = '\\n'; // Escape newline
      } else if (char === '\\') {
        escaped = !escaped;
      } else {
        escaped = false;
      }
    } else {
      if (char === '"') {
        isInsideString = true;
        escaped = false;
      } else if (char === '{') {
        stack.push('}');
      } else if (char === '[') {
        stack.push(']');
      } else if (char === '}' || char === ']') {
        if (stack && stack[stack.length - 1] === char) {
          stack.pop();
        } else {
          return null; // Malformed input
        }
      }
    }

    new_s += char;
  }

  // Close unclosed string
  if (isInsideString) {
    new_s += '"';
  }

  // Close remaining open structures
  for (let i = stack.length - 1; i >= 0; i -= 1) {
    new_s += stack[i];
  }

  // Final parsing attempt
  try {
    return JSON.parse(new_s);
  } catch (error) {
    return null;
  }
}
